module.exports = __webpack_public_path__ + "img/1.0f4b9a53.png";